import React, {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import PasswordlessLoginHandler from '@daedalus/core/src/auth/components/PasswordlessLoginHandler'
import {CognitoPasswordlessHandler} from '@daedalus/core/src/auth/components/CognitoPasswordlessHandler'
import {CognitoLogoutHandler} from '@daedalus/core/src/auth/components/CognitoLogoutHandler'
import {
  LOGIN_CALLBACK_ROUTE,
  COGNITO_LOGIN_CALLBACK_ROUTE,
  COGNITO_LOGOUT_CALLBACK_ROUTE
} from '@daedalus/core/src/auth/constants'

export const ROOM_SELECTION_PAGE_PATH = '/room-selection/'
export const PAYMENT_PAGE_PATH = '/checkout/'
export const CONFIRMATION_PAGE_PATH = '/confirmation/'

const Checkout = lazy(async () =>
  import(
    'views/Checkout'
    /* webpackChunkName: "checkout" */
  )
)

const Confirmation = lazy(async () =>
  import(
    'views/Confirmation'
    /* webpackChunkName: "confirmation" */
  )
)

const RoomSelection = lazy(async () =>
  import(
    'views/RoomSelection'
    /* webpackChunkName: "roomselection" */
  )
)

const Routes = () => (
  <Switch>
    <Route component={Confirmation} path={CONFIRMATION_PAGE_PATH} />
    <Route component={Checkout} path={PAYMENT_PAGE_PATH} />
    <Route component={RoomSelection} path={ROOM_SELECTION_PAGE_PATH} />
    <Route component={PasswordlessLoginHandler} path={LOGIN_CALLBACK_ROUTE} />
    <Route
      component={CognitoPasswordlessHandler}
      path={COGNITO_LOGIN_CALLBACK_ROUTE}
    />
    <Route
      component={CognitoLogoutHandler}
      path={COGNITO_LOGOUT_CALLBACK_ROUTE}
    />
  </Switch>
)

export default Routes
